import React, { useState, useEffect } from 'react'

import type { MenuApiPreferencesResponse } from '@library/menu-service'

import { RecipeList } from '../../../MenuRecipesPage/RecipeList'
import { DetailOverlay } from '../../../components/Detail'

type RecipeGridProps = {
  menuPreferences?: MenuApiPreferencesResponse
}

export const RecipeGrid = ({ menuPreferences }: RecipeGridProps) => {
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false)

  useEffect(() => {
    setShouldShowOverlay(true)
  }, [])

  return (
    <div data-testid="menuRecipesList">
      <RecipeList menuPreferences={menuPreferences} />
      <DetailOverlay showOverlay={shouldShowOverlay} />
    </div>
  )
}
